import React, { useEffect, useState } from "react";
import { Table, Spinner, Alert } from 'react-bootstrap';
import axios from 'axios';

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchOrders = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("Please log in to view your orders.");
        setLoading(false);
        return;
      }

      const response = await axios.get(
        "https://admin.tulikaarts.in/api/orders", // Use your base URL
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // The response structure is { orders: [...] }
      setOrders(response.data.orders);
    } catch (err) {
      console.error("Error fetching orders:", err);
      if (err.response && err.response.status === 401) {
        setError("Session expired. Please log in again.");
      } else {
        setError("Failed to load orders. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  // --- Render Logic ---

  if (loading) {
    return (
      <div className="dashboard-pages-padding text-center" style={{ marginTop: "100px" }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading Orders...</span>
        </Spinner>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-pages-padding" style={{ marginTop: "100px" }}>
        <Alert variant="danger">{error}</Alert>
      </div>
    );
  }

  if (orders.length === 0) {
    return (
      <div className="dashboard-pages-padding text-center" style={{ marginTop: "100px" }}>
        <h1>My Orders</h1>
        <p className="text-muted mt-3">You have not placed any orders yet.</p>
      </div>
    );
  }

  return (
    <div className="dashboard-pages-padding" style={{ marginTop: "100px" }}>
      <h1>My Orders ({orders.length})</h1>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Order No.</th>
            <th>Date</th>
            <th>Total Price</th>
            <th>Items</th>
            <th>Shipping Address</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order, index) => (
            <tr key={order.id}>
              {/* Using order_number for better reference */}
              <td><strong>{order.order_number}</strong></td> 
              <td>{order.order_date}</td> 
              <td>₹{order.total_price}</td>
              <td>
                {/* List all items within the order */}
                {order.items.map((item) => (
                  <div key={item.id} className="small text-nowrap">
                    {item.product_name} (x{item.qty}) - {item.size || 'N/A'}
                  </div>
                ))}
              </td>
              {/* Using shipping_address field created in Laravel GenerateOrder */}
              <td>{order.shipping_address}</td> 
              <td>
                <span className={`badge bg-${order.order_status === 'delivered' ? 'success' : order.order_status === 'new' ? 'primary' : 'warning'}`}>
                    {order.order_status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default MyOrders;